import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import axios from 'axios';
import { toast } from 'react-toastify';

const MachineSwitch = () => {
    const [isOn, setIsOn] = useState(false);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const saved = localStorage.getItem("machine-switch-isOn");
        if(saved !== null) {
            setIsOn(JSON.parse(saved));
        }
    }, []);

    const handleToggle = async (e) => {
        const newState = !e.target.checked;
        setLoading(true);
        setIsOn(newState);
        localStorage.setItem("machine-switch-isOn", JSON.stringify(newState));

        const payload = {
            topic: "esp6201",
            message: {
                state: newState ? "M-ON1".toUpperCase() : "M-OFF1".toUpperCase(),
            },
        };
        //M-ON1 -> off first else on 
        try {
            await axios.post(
                process.env.REACT_APP_IOT_RELAY_ENDPOINT,
                payload,
                {
                    headers: {
                        "Content-Type": "application/json",
                    }
                }
            );
            
            toast.success(`Machine turned ${newState ? 'OFF' : 'ON'} successfully.`);
        } catch(err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };
    console.log(!isOn)
    return (
        <>
            <FormControlLabel
                control={
                    <Switch
                        checked={!isOn}
                        color="primary"
                        onChange={handleToggle}
                        disabled={loading}
                    />
                }
                label={isOn ? "Machine Off" : "Machine On"}
            />
        </>
    );
}

export default MachineSwitch;
